$(function () {
  // var h1 = $(".collection-product-list li:first-child .product-card-front").innerHeight();
  // $('.collection-product-list .collection-product-card').css('min-height', h1);
  var maxHeight = Math.max.apply(null, $(".collection-product-list li .product-card-front").map(function (){
    return $(this).height();
  }).get());
  $('.collection-product-list .collection-product-card').css('min-height', maxHeight);
});

$(document).ready(function(){
  // Product page
  $(".product__media-flip").flip();
  var x = 'front';
  $(".product__media-flip").on('flip:done',function(){
    $(".product__media-flip .font, .product__media-flip .back").css("height", "auto");
    if(x == 'front'){
      x = 'back';
      var h = $(".product__media-flip .back").height();
      $(".product__media-flip .front").css("height", h);
    }else{
      x = 'front';
      var h = $(".product__media-flip .front").height();
      $(".product__media-flip .back").css("height", h);
    }
  });
  var h = $(".product__media-flip .front").height();
  $(".product__media-flip .back").css("height", h);

  // Collection page
  $(".card-wrapper").flip({autoSize:false});
  $(".card-wrapper").on('click', function (e) {
    if ($(e.target).closest(".flip-icon img").length === 0) {
       $(this).flip(false);
    }
  });
  $(".product-card-front .flip-icon img").click(function(){
    $(".card-wrapper").flip(false);
    var id = $(this).data("id");
    $("#product_card_"+id).flip();
  });
  var t = 'front';
  $(".card-wrapper").on('flip:done',function(){
    if(t == 'front'){
      t = 'back';
      $(this).addClass("flipped");
    }else{
      t = 'front';
      $(this).removeClass("flipped");
    }
  });

  $(".card-wrapper .card--product").click(function(){
    var url = $(this).data("url");
    window.location.href=url;
  });
});


$(document).ready(function(){
  function adjustCardHeights() {
    $(".card-wrapper").flip({autoSize:false});

    $(".card-wrapper .product-card-back").each(function(){

      const frontSide = $(this).parent().find(".product-card-front");
      const backHeight = $(this).height();
      const frontHeight = frontSide.height();

      if (backHeight > frontHeight) {
        frontSide.css("height", backHeight);
      } else {
        $(this).css("height", frontHeight);
      }

      const backsideImageContainer = $(this).find(".card--product");
      const backsideImage = backsideImageContainer.find("img");
      backsideImage.css("height", backsideImageContainer.height());
    });
  }

  adjustCardHeights();

  $(document).on('DOMNodeInserted', function(event) {
    if ($(event.target).find(".product-card-back").length > 0 || $(event.target).hasClass("product-card-back")) {
      adjustCardHeights();
    }
  });
});